<template>
  <div>
    <v-row justify="center">
      <v-dialog max-width="900px" persistent v-model="dialogFormSearch">
        <v-card>
          <v-toolbar color="grey lighten-4" flat>
            <v-toolbar-title class="text-h6">Consultar Veículo</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-form @submit.prevent="submit" lazy-validation ref="form">
            <v-card-text class="pb-0">
              <v-container fluid>
                <v-row>
                  <v-col class="py-0" cols="6" md="6">
                    <v-text-field
                      class="pa-0"
                      dense
                      label="Motorista"
                      outlined
                      v-model="formData.motorista"
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-0" md="3" cols="12">
                    <v-autocomplete
                      label="Marcas"
                      v-model="formData.marca"
                      :items="marcas"
                      outlined
                      hide-no-data
                      hide-selected
                      item-text="nome"
                      item-value="id"
                      :aria-autocomplete="false"
                      clearable
                      dense
                      :loading="isloadingMarcas"
                      @change="loadModelos"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col class="py-0" md="3" cols="12">
                    <v-autocomplete
                      label="Modelos"
                      v-model="formData.modelo"
                      :items="modelos"
                      outlined
                      hide-no-data
                      hide-selected
                      item-text="nome"
                      item-value="id"
                      :aria-autocomplete="false"
                      clearable
                      dense
                      :loading="isloadingModelos"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col class="py-0" cols="12" md="2">
                    <v-text-field
                      class="pa-0"
                      dense
                      label="Placa"
                      outlined
                      v-model="formData.placa"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col class="py-0" cols="12" md="5">
                    <v-autocomplete
                      label="Vínculo"
                      v-model="formData.vinculo"
                      :items="vinculos"
                      outlined
                      hide-no-data
                      hide-selected
                      item-text="nome"
                      item-value="id"
                      :aria-autocomplete="false"
                      clearable
                      dense
                      :loading="isloadingVinculos"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col class="py-0" cols="12" md="5">
                    <v-autocomplete
                      label="Lotação"
                      v-model="formData.lotacao"
                      :items="lotacoes"
                      outlined
                      hide-no-data
                      hide-selected
                      item-text="nome"
                      item-value="id"
                      :aria-autocomplete="false"
                      clearable
                      dense
                      :loading="isloadingLotacoes"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" cols="12" md="6">
                    <v-autocomplete
                      label="Situação"
                      v-model="formData.situacao"
                      :items="situacao"
                      outlined
                      hide-no-data
                      hide-selected
                      :aria-autocomplete="false"
                      clearable
                      dense
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col class="py-0" cols="12" md="6">
                    <v-autocomplete
                      label="Importado"
                      v-model="formData.importado"
                      :items="importado"
                      outlined
                      hide-no-data
                      hide-selected
                      :aria-autocomplete="false"
                      clearable
                      dense
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="pa-4">
              <v-spacer></v-spacer>
              <v-btn @click="toggleFormSearch" color="red" dark depressed>
                <v-icon left small>mdi-close</v-icon>
                Fechar
              </v-btn>
              <v-btn :loading="loadingSubmit" color="primary" dark depressed type="submit">
                <v-icon left small>mdi-magnify</v-icon>
                Buscar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import toastMessage from '@/services/util/alertService';
import sessionStorage from '@/services/util/sessionStorage';
import marcaHttp from '@/services/http/resources/frota/marcaHttp';
import modeloHttp from '@/services/http/resources/frota/modeloHttp';
import vinculoHttp from '@/services/http/resources/frota/vinculoHttp';
import orgaoHttp from '@/services/http/resources/configuracao/orgaoHttp';

export default {
  name: 'VeiculoModalFormSearch',
  data: () => ({
    valid: true,
    marcas: [],
    modelos: [],
    vinculos: [],
    lotacoes: [],
    situacao: [
      { value: 'A', text: 'Ativo' },
      { value: 'I', text: 'Inativo' },
    ],
    importado: [
      { value: 'S', text: 'Sim' },
      { value: 'N', text: 'Não' },
    ],
    formData: {
      motorista: '',
      marca: '',
      modelo: '',
      vinculo: '',
      placa: '',
      lotacao: '',
      situacao: 'A',
      importado: 'N',
    },
    formDataDefault: {
      motorista: '',
      marca: '',
      modelo: '',
      vinculo: '',
      placa: '',
      lotacao: '',
      situacao: 'A',
      importado: 'N',
    },
    loadingSubmit: false,
    isloadingMarcas: false,
    isloadingModelos: false,
    isloadingVinculos: false,
    isloadingLotacoes: false,
  }),
  created() {
    this.loadAll();
  },
  computed: {
    ...mapState('veiculo', ['dialogFormSearch']),
  },
  methods: {
    ...mapActions('veiculo', ['toggleFormSearch', 'filter']),
    submit() {
      this.loadingSubmit = true;
      this.filter(this.formData)
        .then(() => {
          sessionStorage.setObject('consulta_veiculo', this.formData);
          toastMessage.successSave('Consulta efetuada com sucesso.');
        })
        .catch(() => {
          toastMessage.errorLoading('Erro ao buscar motoristas.');
        })
        .finally(() => {
          this.loadingSubmit = false;
        });
    },
    async loadAll() {
      this.loading = true;
      await Promise.all([this.loadMarcas(), this.loadVinculos(), this.loadLotacoes()])
        .catch(() => {
          toastMessage.errorLoading('Erro ao carregar dados.');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async loadMarcas() {
      this.isloadingMarcas = true;
      await marcaHttp
        .list()
        .then(({ data: { data } }) => {
          this.marcas = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar Marcas'))
        .finally(() => {
          this.isloadingMarcas = false;
        });
    },
    async loadLotacoes() {
      this.isloadingLotacoes = true;
      await orgaoHttp
        .list()
        .then(({ data: { data } }) => {
          this.lotacoes = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar Lotações'))
        .finally(() => {
          this.isloadingLotacoes = false;
        });
    },
    async loadModelos() {
      if (!this.formData.marca) return;
      this.isloadingModelos = true;
      await modeloHttp
        .list(this.formData.marca)
        .then(({ data: { data } }) => {
          this.modelos = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar Modelos'))
        .finally(() => {
          this.isloadingModelos = false;
        });
    },
    async loadVinculos() {
      this.isloadingVinculos = true;
      await vinculoHttp
        .list()
        .then(({ data: { data } }) => {
          this.vinculos = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar Vínculos'))
        .finally(() => {
          this.isloadingVinculos = false;
        });
    },
    openDialog() {},
    closeDialog() {
      setTimeout(() => {
        Object.entries(this.formDataDefault).forEach(([key]) => {
          this.formData[key] = this.formDataDefault[key];
        });
      }, 300);
    },
  },
  watch: {
    dialogFormSearch(value) {
      if (value) {
        this.openDialog();
      } else {
        this.closeDialog();
      }
    },
  },
};
</script>

<style lang="scss">
.v-input__append-outer {
  .v-btn {
    margin-top: -5px;
  }
}
</style>
